export const MODULE_NAME = 'travel-header';
export const CENTURION = 'Centurion';
export const E3 = 'e3';
export const ESCAPE_KEY = 'Escape';
export const oneCmsInternetConfigLinks = {
  e1: 'https://inter-pdgemapp.aexp.com',
  e2: 'https://qicm.aexp-static.com',
  e3: 'https://icm.aexp-static.com',
};
